module.exports = __webpack_public_path__ + "img/video_1.6eb048be.png";